import { StyleSheet, View, ViewProps } from 'react-native'
import { Spacing } from 'zens-storybook'
import { Suspense } from 'react'
import { InsightTimeType } from 'zens-store'
import { useNumberParams, useParams, usePeriodParam, useWeekdaysParam, useWorkingHoursParam } from 'zens-router'

import {
  InsightsHead,
  InsightsSummary,
  InsightsOverviewGraph,
  InsightsHeatmapSummary,
  InsightsTrendGrid,
  LayoutHeader,
  InsightsHeader,
} from '@dms/component'

const styles = StyleSheet.create({
  container: {
    flex: 1,
  },
  content: {
    margin: Spacing.L,
  },
  block: {
    marginTop: Spacing.M,
  },
  head: {
    zIndex: 100,
  },
  row: {
    flexDirection: 'row',
    marginHorizontal: -Spacing.S,
  },
  rowBlock: {
    marginHorizontal: Spacing.S,
  },
})

interface Props extends ViewProps {}

const InsightsOverview = (props: Props) => {
  const { style, ...otherProps } = props
  const [{ companyId, buildingId, floorId }] = useNumberParams()
  const [period] = usePeriodParam()
  const [weekdays] = useWeekdaysParam()
  const [workingHours] = useWorkingHoursParam()
  const [{ timeType }, setParams] = useParams()

  return (
    <View style={[styles.container, style]} {...otherProps}>
      <Suspense fallback={<LayoutHeader.Skeleton breadcrumb title />}>
        <InsightsHeader companyId={companyId} buildingId={buildingId} />
      </Suspense>
      <View style={styles.content}>
        <Suspense fallback={<InsightsHead.Skeleton />}>
          <InsightsHead
            style={styles.head}
            companyId={companyId}
            buildingId={buildingId}
            href={(buildingId, floorId = 0) => ({
              pathname: `/companies/${companyId}/insights/${buildingId}`,
              params: { floorId },
            })}
          />
        </Suspense>
        <Suspense fallback={<InsightsSummary.Skeleton style={styles.block} />}>
          <InsightsSummary
            companyId={companyId}
            buildingId={buildingId}
            floorId={floorId}
            style={styles.block}
            period={period}
            weekdays={weekdays}
            workingHours={workingHours}
            type={timeType as InsightTimeType}
          />
        </Suspense>
        <Suspense fallback={<InsightsOverviewGraph.Skeleton style={styles.block} />}>
          <InsightsOverviewGraph
            style={styles.block}
            companyId={companyId}
            buildingId={buildingId}
            floorId={floorId}
            period={period}
            weekdays={weekdays}
            workingHours={workingHours}
            type={timeType as InsightTimeType}
            onChangeType={(timeType) => setParams({ timeType })}
          />
        </Suspense>
        <View style={[styles.block, styles.row]}>
          <Suspense fallback={<InsightsHeatmapSummary.Skeleton style={styles.rowBlock} />}>
            <InsightsHeatmapSummary
              style={styles.rowBlock}
              companyId={companyId}
              buildingId={buildingId}
              floorId={floorId}
              period={period}
              weekdays={weekdays}
              workingHours={workingHours}
            />
          </Suspense>
          <InsightsTrendGrid style={styles.rowBlock} companyId={companyId} buildingId={buildingId} />
        </View>
      </View>
    </View>
  )
}

export default InsightsOverview
